<template>
  <div
    class="group"
    v-if="group[0].Parent != $store.getters.pageTitle"
    :class="{'has-selected-category': groupHasSelectedCategory}"
  >
    <span @click="toggleGroup">
      {{group[0].Parent}}
      <fa v-if="expanded" icon="caret-up" />
      <fa v-else icon="caret-down" />
    </span>
    <div class="group-container" v-show="expanded">
      <li
        v-for="(subCategory, index) in sortedSubCategories"
        :key="index"
        :class="{'selected' : selectedSubCategories.indexOf(subCategory.Name) != -1}"
        @click="setSubFilter(subCategory.Name)"
      >{{subCategory.Name}}</li>
    </div>
  </div>
</template>

<script>
export default {
  props: ["group"],
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    setSubFilter(categoryName) {
      this.$store.dispatch("setSelectedSubCategory", categoryName);
    },
    toggleGroup() {
      this.expanded = !this.expanded;
    }
  },
  computed: {
    sortedSubCategories() {
      let group = this.group
      return group.sort((a,b) => a.Name.localeCompare(b.Name));
    },
    selectedSubCategories() {
      return this.$store.getters.selectedSubCategories;
    },
    groupHasSelectedCategory() {
      const groupCategories = this.group.map(cat => cat.Name);
      const groupHasSelectedCategory = groupCategories.find(category => {
        return this.selectedSubCategories.indexOf(category) != -1;
      });
      return groupHasSelectedCategory != undefined;
    }
  }
};
</script>